'use es6';

import attribute from './attribute';
attribute(window.ire, window.location, window.document, window.enviro);